import { useDispatch, useSelector } from "react-redux";
import { FileUploader } from "../../components";
import { useFormContext } from "react-hook-form";
import { RootState } from "../../store/root-reducer";
import {
  removeClaimImage,
  uploadClaimImage,
} from "../../store/mattress-claim/actions";

function UploadDocuments() {
  const { control } = useFormContext();
  const claim = useSelector((state: RootState) => state.claim);
  const dispatch = useDispatch();

  return (
    <div className="grid gap-y-6">
      <FileUploader
        required
        control={control}
        name="documents.protector_damage_images"
        label="Three (3) photos of the stained or damaged product"
        isMultiple
        uploadedFiles={claim.protector_damage_images}
        minFile={3}
        onlyImage
        onFileSelect={(files) =>
          dispatch(
            uploadClaimImage({
              files,
              fieldName: "protector_damage_images",
              isMultiple: true,
            })
          )
        }
        onDeleteImage={(fileName) =>
          dispatch(
            removeClaimImage({ fileName, fieldName: "protector_damage_images" })
          )
        }
      />
      {claim.mattress_stained_damaged && (
        <FileUploader
          required
          control={control}
          name="documents.mattress_damage_images"
          label="Three (3) photos of the stained or damaged mattress"
          isMultiple
          onlyImage
          uploadedFiles={claim.mattress_damage_images}
          minFile={3}
          onFileSelect={(files) =>
            dispatch(
              uploadClaimImage({
                files,
                fieldName: "mattress_damage_images",
                isMultiple: true,
              })
            )
          }
          onDeleteImage={(fileName) =>
            dispatch(
              removeClaimImage({
                fileName,
                fieldName: "mattress_damage_images",
              })
            )
          }
        />
      )}
      <FileUploader
        control={control}
        name="documents.protectall_tag_image"
        label="ProtectALL Product Tag Photo: Photo of tag or label on the product with name and date written on it."
        required
        onlyImage
        uploadedFiles={
          claim.protectall_tag_image ? [claim.protectall_tag_image] : []
        }
        onFileSelect={(files) =>
          dispatch(
            uploadClaimImage({ files, fieldName: "protectall_tag_image" })
          )
        }
      />
    </div>
  );
}

export default UploadDocuments;
